import AuditLogTypes from './types';

const initialState = {
    auditLog: { data: [] },
    fetchingAuditLog: false,
    error: null
};

function auditLogReducer( state = initialState, { type, payload }) {
    switch (type) {
        case AuditLogTypes.FETCH_AUDIT_LOG_START:
            return {
                ...state,
                fetchingAuditLog: true,
            };
        case AuditLogTypes.FETCH_AUDIT_LOG_SUCCESS:
            return {
                ...state,
                fetchingAuditLog: false,
                auditLog: payload,
            };
        case AuditLogTypes.FETCH_AUDIT_LOG_FAILURE:
            return {
                ...state,
                fetchingAuditLog: false,
                error: payload
            };
        default:
            return state;
    }
}

export default auditLogReducer;